import React from "react";

export const renderDangerHTML = (rawHTML: string, className: string = '', type: string = 'div') => React.createElement(
    type,
    {
        dangerouslySetInnerHTML: { __html: rawHTML },
        className
    });